<template>
    <div class="font-md">
        <div class="
            lines:2
            {lines:1;h:24}@md
            {px:8;h:24;lh:24px;color:gray500}>span
            {inline}>span>h1
            {color:gray500}_a
            {color:gray800}_a:hover
            {pr:28;rel}>span:not(:last-child)
            {content:'';abs;background-image:url(images/breadcrumb_arrow.svg);right:0;top:50%;translateY(-50%);w:20;h:20}>span:not(:last-child)::after
        ">
            <slot></slot>
        </div>
    </div>
</template>
